/* ============
 * Main File
 * ============
 *
 * Will initialize the application.
 */

import Vue from 'vue'
import { AdminRouter, AdminStore, AuthMixin } from 'stylemix-vue-admin'
import App from '../../console/src/App'

/* ============
 * Styling
 * ============
 *
 * Import the application styling.
 */
import '../../console/src/assets/scss/tailwind.scss'
import './assets/scss/app.scss'

/* ============
 * Plugins
 * ============
 */
import './plugins/admin'
import '../../console/src/plugins/base'
import { messageGroups } from './plugins/i18n'
import '../../console/src/plugins/thumbnail'
import AppConfig from '../../console/src/settings/AppConfig'
import '../../console/src/language-switcher/module'
import LanguageMixin from '../../console/src/language-switcher/LanguageMixin'
import '../../console/src/gate/module'
import GateMixin from '../../console/src/gate/GateMixin'
import adminMenuStore from '../../console/src/admin-menu/store'

if (typeof window !== 'undefined') window.__MENU_TYPE__ = 'personal'
import { FETCH_MENU } from '../../console/src/admin-menu/store'

AdminStore.registerModule('adminMenu', adminMenuStore)

// required for widget
window.Vue = Vue

// Include translations for vendor packages
messageGroups.push('vendor')

/**
 * Module system
 * Scan for module.js file in each first level directories
 */
const modules = require.context('.', true, /module\.js/)
modules.keys().forEach(module => {
  modules(module)
})

Vue.config.ignoredElements = ['at-widget-booking']
/* ============
 * Main App
 * ============
 *
 * Last but not least, we import the main application.
 */

/* eslint-disable no-new */
new Vue({
  /**
   * Bind the Vue instance to the HTML.
   */
  el: '#app',

  /**
   * The router.
   */
  router: AdminRouter,

  /**
   * The Vuex store.
   */
  store: AdminStore,

  mixins: [AppConfig, AuthMixin, GateMixin, LanguageMixin],

  data: () => ({
    ready: false,
  }),

  watch: {
    $account: function() {
      this.injectScripts()
    },
    $settings: {
      handler() {
        this.injectScripts()
      },
      deep: true,
    }
  },

  beforeCreate() {
    this.$on('account-loaded', () => {
      if (process.env.VUE_APP_USE_API_MENU === 'true') {
        AdminStore.dispatch(`adminMenu/${FETCH_MENU}`).catch(() => {})
      }
    })
  },

  created() {
    this.onResizeEvent()
    window.addEventListener('resize', this.onResizeEvent)
  },

  mounted() {
    this.injectScripts()
  },

  methods: {
    setReady() {
      this.ready = true
      document.getElementById('page-loader').style.display = 'none'
    },
    onResizeEvent() {
      // hide sidebar if window width less than 1400
      const body = document.body
      screen.width < 1400
        ? body.classList.add('sidebar-xs')
        : body.classList.remove('sidebar-xs')
    },
    injectScripts() {
      if (this.$account === null || !this.$settings.footer_scripts) {
        return
      }
      const footerScript = this.$settings.footer_scripts[this.$account.language ?? 'en'];
      const templateElement = document.createElement('template')
      templateElement.innerHTML = (footerScript || '').trim()

      templateElement.content.childNodes.forEach(node => {
        if (!node.innerText || node.innerText.trim().length === 0) {
          if(node.nodeName === 'SCRIPT') {
            const s_script = document.createElement('script')
            s_script.setAttribute("src", node.getAttribute("src"));
            document.body.appendChild(s_script)
          }
          if(['DIV'].indexOf(node.nodeName) > -1) {
            document.body.appendChild(node)
          }
         return
        }
        const script = document.createElement('script')
        script.append(document.createTextNode(node.innerText))
        document.body.appendChild(script)
      })
    },
  },

  /**
   * Will render the application.
   *
   * @param {Function} h Will create an element.
   */
  render(h) {
    return this.ready ? h(App) : null
  },
})
